import { CCTM, CCTM_demo, CCTM_item, CCTM_link, CCTM_route, Link, useCCTM, useModel } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView } from "components/shared";
import { SVGAsset } from "res";
import "./styles.css";


/**
 * @function AccountSummaryAccountCustomLinksWidget
 * @param {STRING} type - The account type, like "Checking" or "Savings". 
 * @returns {React.Component}
 * @description A component for the custom links (set through CCTM) shown beneath accounts in the widget
 * "Account Summary With Sortable Table and Links".
 */
export default function AccountSummaryAccountCustomLinksWidget(props) {
    const xml = useCCTM();
    const { demos } = useModel();
    const useTableRowWrapper = props.useTableWrapper ?? false;
    const useWrapper = useTableRowWrapper ? TableRowWrapper : Wrapper;

    return (
        <CCTM nav-id={ `accountSummaryTableCustomLinksFor${ props.type }Accounts` } xml={ xml } self={ useWrapper }>
            <CCTM_route component={ CustomLink } />
            <CCTM_link component={ CustomLink } />
            <CCTM_item component={ CustomLink } />
            <CCTM_demo component={ CustomLink } demos={demos}/>
        </CCTM>
    );
}

function Wrapper(props) {
    return <span className={ `custom-account-links-wrapper flex-container flex-horizontal flex-wrap align-center` }>{ props.children }</span>
}

function CustomLink(props) {
    const label = props.label ?? "";
    const onClick = props.onClick ? { onClick: props.onClick } : {};
    const to = props.onClick ? {} : { to: props.to };
    const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
    const labelCustomClass = props["custom-class"] ? { className: props["custom-class"] } : {}; 
    const linkClassName = { className: `flex-container flex-horizontal  custom-account-link` };
    const assetName = props.asset_name;
    const assetCustomClass = props["asset_custom-class"];
    const assetClassName = assetCustomClass ? { className: `${ assetCustomClass }` } : {};
    const hasCustomIcon = assetName ?? false;

    const link = (
        <>
            { hasCustomIcon ? <div className="set-width icon-container"><SVGAsset id={ assetName } { ...assetClassName } /></div> : undefined }
            <div className="set-width custom-link-label">{ <span { ...labelCustomClass } { ...dataPoint }>{ label }</span> }</div>
        </>
    );

    return (
        <div className="custom-account-link-container">
            <Link { ...linkClassName } { ...onClick } { ...to }>{ link }</Link>
        </div>  
    );
}

/**
 * @function TableRowWrapper
 * @param {OBJECT} props 
 * @returns {React.Component}
 * @description A custom table row used in the "Account Summary" page. 
 * Used in order to note if there are child items rendered through the custom class "no-children".
 */
function TableRowWrapper(props) {
    const hasChildren = props.children.length > 0;

    return (
        <TableItemContainer className="account-summary-sortable-view clickable">
            <TableItemTextView className={ `${ hasChildren ? "" : "no-children" }` } colSpan={ 5 } text={ <span className={ `custom-account-links-wrapper flex-container flex-horizontal flex-wrap align-center ${ hasChildren ? "" : "no-children" }` }>{ props.children }</span> }/>
        </TableItemContainer>
    );
}